// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-text {\n  color: red;\n}\n.btn-swal-error {\n  background-color: #fff;\n  color: #545454;\n  font-weight: bold;\n  border: 2px solid #545454;\n  padding: 10px 10px;\n  text-transform: uppercase;\n  border-radius: 4px;\n}\n.btn-swal-error:hover {\n  background-color: #f8f7f7;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
